//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import experimentMixin from '@motionelements/core/src/components/mixins/experiment-variation.mixin.js';

export default {
  name: 'SubscribeForm2026',
  components: {
    SubscribeForm2026PlanHeader: () => import('@/components/subscribe2026/SubscribeForm2026PlanHeader.vue'),
    SubscribePlanSwitcher: () => import('@/components/subscribe2026/SubscribePlanSwitcher.vue'),
    SubscribePrice: () => import('@/components/subscribe/price/SubscribePrice.vue'),
  },
  mixins: [experimentMixin],
  data() {
    return {
      faCheck,
      planType: 'unlimited',
    };
  },
  computed: {
    /** ?x=0 (ai_no_switcher) hides the stock/AI plan toggle. */
    showPlanSwitcher() {
      return this.experimentVariation !== '0';
    },
    planFeatures() {
      return [
        this.$t('subscribe.form_2026_feature_catalog_downloads'),
        this.$t('subscribe.form_2026_feature_ai_remix'),
        this.$t('subscribe.form_2026_feature_ai_coins'),
        this.$t('subscribe.form_2026_feature_commercial_license'),
      ];
    },
  },
  watch: {
    planType(val, oldVal) {
      console.log('=========== WATCH planType ', oldVal, val);
      if (oldVal && val === 'ai-only') {
        window.location.href = this.$link('/pricing').aiUrl();
      }
    },
  },
};
